module.exports = __webpack_public_path__ + "static/media/cardinal.97e26f41.png";